import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const CardContainer = styled.div`
  position: relative;
  background: ${colors.white};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  width: auto;
  height: 265px;
  cursor: auto;
  border-radius: 5px;
  transition: all 0.25s ease-in-out;
  backface-visibility: hidden;
  transform: scale(1);
  overflow: hidden;

  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${(props) => props.maxWidth};
    `}

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${(props) => props.minHeight};
      height: auto;
    `}

  :hover {
    transform: scale(1.02);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
    animation-fill-mode: forwards;
  }
`;

export const Image = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  background-image: url(${(props) => props.image || ''});
  background-size: cover;
  background-position: center center;
`;

export const ChallengeInfo = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
`;

export const ChallengeInfoHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChallengeName = styled.span`
  font-size: 14px;
  padding-bottom: 10px;
  color: ${colors.darkBlue};
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: pre;
`;

export const ChallengeDetails = styled.div`
  font-size: 12px;
`;

export const DetailsLabel = styled.label`
  font-weight: 600;
  margin-bottom: 0;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 5px 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  position: relative;
`;

export const Title = styled.span`
  text-transform: uppercase;
  color: ${colors.lightGray2};
  font-size: 14px;
  font-weight: bold;
`;

export const Hr = styled.hr`
  border: 0;
  height: 1px;
  background: ${colors.lightGray2};
  width: 100%;
  margin: 0 0 2px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const HeadingButtonContainer = styled.div`
  display: flex;
  justify-content: end;
`;
